import { render } from "./FeaturedPublication.vue?vue&type=template&id=fc1097e0&scoped=true"
import script from "./FeaturedPublication.vue?vue&type=script&lang=js"
export * from "./FeaturedPublication.vue?vue&type=script&lang=js"

import "./FeaturedPublication.vue?vue&type=style&index=0&id=fc1097e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc1097e0"]])

export default __exports__